export const version = '12.5.1';
export const buildDate = '2025-05-13T11:52:57.261Z';
export const commitHash = 'a0a309f';